import { render, staticRenderFns } from "./ReasonTable.vue?vue&type=template&id=2c40d8a2&"
import script from "./ReasonTable.vue?vue&type=script&lang=js&"
export * from "./ReasonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports